
    var riot = require('riot')
    //src: starling/src/tags/perspective-settings-text-menu.html
riot.tag2('perspective-settings-text-menu',
  '<ul class="floating-menu_list"> <li class=" floating-menu_item floating-menu_item--{isActiveOption(\'popout\') ? \'active\' : \'iconless\'} " onclick="{setLayout.bind(null, \'popout\')}"> <svg if="{isActiveOption(\'popout\')}" class="floating-menu_icon"> <use xlink:href="#check-icon"></use> </svg> <span class="floating-menu_label">Popped out</span> </li> <li class=" floating-menu_item floating-menu_item--{isActiveOption(\'in_card\') ? \'active\' : \'iconless\'} " onclick="{setLayout.bind(null, \'in_card\')}"> <svg if="{isActiveOption(\'in_card\')}" class="floating-menu_icon"> <use xlink:href="#check-icon"></use> </svg> <span class="floating-menu_label">In card</span> </li> </ul>',
  '',
  'class="floating-menu floating-menu--hidden" riot-style="{getStyle()}"', function(opts) {
'use strict';

var _this = this;

var _perspectivesUi = require('lib/perspectives-ui');

this.canvas = opts.canvas;
this.operation = opts.operation;
this.canvas.perspectiveSettingsTextMenu = this;
this.top = 0;
this.left = 0;

this.show = function (opts) {
  if (opts.spawnedFromElement) {
    var rect = opts.spawnedFromElement.getBoundingClientRect();
    _this.left = rect.right;
    _this.top = rect.top;
  }
  _this.summoned = true;
  _this.update();
  _this.root.classList.remove('floating-menu--hidden');
};

this.hide = function () {
  _this.summoned = false;
  _this.root.classList.add('floating-menu--hidden');
};

this.getStyle = function () {
  return 'top: ' + _this.top + 'px; left: ' + _this.left + 'px';
};

this.isActiveOption = function (option) {
  if (_this.canvas.annotationStyle == option) {
    return true;
  }
  return false;
};

this.setLayout = function (option) {
  _perspectivesUi.pui.setAnnotationLayout(option);
  _this.update();
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('perspective-settings-text-menu')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/perspective-settings-text-menu.html
// module id = 663
// module chunks = 0